import { render, staticRenderFns } from "./beacons.vue?vue&type=template&id=4f39954a&"
import script from "./beacons.vue?vue&type=script&lang=js&"
export * from "./beacons.vue?vue&type=script&lang=js&"
import style0 from "./beacons.vue?vue&type=style&index=0&id=4f39954a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports